// extracted by mini-css-extract-plugin
module.exports = {"menu":"CardMenu_menu__W5MX5"};